import React from 'react';
import Helmet from 'react-helmet';
import {
    Container, Row, Col,
    Card, CardImg, CardText, CardBody,
    CardTitle, CardSubtitle, Button
  } from 'reactstrap';
import SiteNavbar from './navbar';
import {SITE_TITLE} from './const';

export default function Layout({children}) {
    return <div>

        <Helmet>
            <title>{SITE_TITLE}</title>
        </Helmet>

        <div className="mb-3">
            <SiteNavbar/>
        </div>

        <Container>

            {children}

            <hr/>

            <footer className="text-right">
                &copy; {(new Date()).getFullYear()}
            </footer>

        </Container>
    </div>;
}
